import React, { useRef, useState, useEffect } from "react";
import { Button, message } from "antd";
import { YhBox } from "@/components/YhBox";
import { YhFormBox } from "@/components/YhFormBox";
import { IYhFormBox, IYhFormItemsBox, FormItemTypeEnum, IYhFormRef } from "@/components/YhFormBox/Types";
import { useCustomerModel } from "../baseCustomerModel";
import { YhPageHeader } from "@/components/YhPageHeader";
import useNavModel, { RouterParamType } from "@/model/navModel";
import { IVRMCustomerDetail } from "../baseCustomerService";
import { getFormValidatorErrText } from "@/utils/utils"
import { useDictModel } from "../../../dict/dictModel";
import { DictCodeEnmu } from "@/types/VrmSaDictEnums"
import useGlobalModel from "@/model/globalModel";
import zh_CN from "@/locale/zh-CN";
import en_US from "@/locale/en-US";
import { debounce } from "lodash";
export const BaseCustomerDetails = () => {
    let LanguageArr: any = {
        "zh-CN": zh_CN,
        "en-US": en_US
    }
    const { setLocale } = useGlobalModel()
    const Locale = setLocale(LanguageArr)

    const {
        addFormVal,
        editFormVal,
        updateAddFormVal,
        updateEditFormVal,
        insertCustomer,
        editCustomer,
        getCustomerOne,
        setAddFormVal,
        setSelectedRowKeys
    } = useCustomerModel();
    const { getTreeSelectOne, getSelectedDictOne } = useDictModel();
    const { selectedNavId, replaceNav, getSelectedNavState, findNav } = useNavModel();
    const formRef = useRef<IYhFormRef>();
    const [detailsInfo] = useState<RouterParamType>(getSelectedNavState() as RouterParamType);

    //编辑时， 没有缓在调用详情接口
    useEffect(() => {
        if (!Object.keys(editFormVal).length && detailsInfo.mode === "edit") {
            getCustomerOne(detailsInfo.id)
        }
    }, [detailsInfo]);

    useEffect(() => {
        return () => {
            let addNavExist = findNav("13-5-1-1");
            let editNavExist = findNav("13-5-1-2");
            !addNavExist && updateAddFormVal(null);
            !editNavExist && updateEditFormVal(null);
        }
    }, [])

    //关闭当前页
    const onClose = () => {
        let { parentInfo } = detailsInfo
        if (parentInfo) {
            replaceNav(selectedNavId, parentInfo.selectedNavId);
        } else {
            replaceNav(selectedNavId, "13-5-1");
            detailsInfo.mode === "edit" ? updateEditFormVal(null) : updateAddFormVal(null);
        }
    }

    //表单提交
    const onSubmit = async () => {
        formRef.current?.validateFields().then(res => {
            if (detailsInfo.mode === "edit") {
                editCustomer({ ...res, id: detailsInfo.id } as IVRMCustomerDetail).then(res => {
                    res && onClose()
                })
            } else {
                insertCustomer(res as IVRMCustomerDetail).then(res => {
                    if(res){
                        setSelectedRowKeys([res])
                        onClose()
                    }
                    // res && onClose()
                })
            }
        }).catch(err => {
            message.warning(getFormValidatorErrText(err));
        })
    }

    //实时保留缓存
    const onChange = (changedValues: { [key: string]: any }) => {
        detailsInfo.mode === "edit" ? updateEditFormVal(changedValues) : updateAddFormVal(changedValues);
    }

    const baseFormItem: IYhFormItemsBox = {
        // title: "基础信息",
        title: Locale["Basic Info"],
        style: { padding: "18px 77px 0 0", marginBottom: "15px" },
        items: [
            {
                type: FormItemTypeEnum.Input,
                // fieldLabel: "客户编码",
                fieldLabel: Locale["Customer Code"],
                fieldName: "code",
                disable: true,
                placeholder: "自动生成"
            }, {
                type: FormItemTypeEnum.Input,
                // fieldLabel: "客户名称",
                fieldLabel: Locale["Customer"],
                fieldName: "name",
                rules: [{ required: true, message: "请输入客户名称" }]
            }, {
                type: FormItemTypeEnum.Input,
                // fieldLabel: "联系人",
                fieldLabel: Locale["Contact"],
                fieldName: "contact",
                rules: [{ required: true, message: "请输入联系人" }]
            }, {
                type: FormItemTypeEnum.Input,
                // fieldLabel: "联系电话",
                fieldLabel: Locale["Contact Number"],
                fieldName: "phone",
                rules: [{ required: true, message: "请输入联系电话" }]
            }, {
                type: FormItemTypeEnum.TreeSelect,
                // fieldLabel: "客户类型",
                fieldLabel: Locale["Customer Type"],
                fieldName: "categoryCode",
                treeData: getTreeSelectOne(DictCodeEnmu.CUSTOMER_TYPE),
                rules: [{ required: true, message: "请选择客户类型" }]
            }, {
                type: FormItemTypeEnum.Input,
                // fieldLabel: "电子邮箱",
                fieldLabel: Locale["Email"],
                fieldName: "email"
            }, {
                type: FormItemTypeEnum.Input,
                // fieldLabel: "办公电话",
                fieldLabel: Locale["Office Tel"],
                fieldName: "tel",
            }, {
                type: FormItemTypeEnum.Input,
                // fieldLabel: "联系地址",
                fieldLabel: Locale["Address"],
                fieldName: "address",
                rules: [{ required: true, message: "请输入联系地址" }]
            }, {
                type: FormItemTypeEnum.Input,
                // fieldLabel: "登记日期",
                fieldLabel: Locale["Record Time"],
                fieldName: "createTime",
                disable: true
            }, {
                type: FormItemTypeEnum.Input,
                // fieldLabel: "邮编",
                fieldLabel: Locale["Postcode"],
                fieldName: "postCode",
            }, {
                type: FormItemTypeEnum.Input,
                // fieldLabel: "备注",
                fieldLabel: Locale["Note"],
                fieldName: "note"
            }, {
                type: FormItemTypeEnum.Switch,
                // fieldLabel: "客户状态",
                fieldLabel: Locale["Customer Status"],
                fieldName: "enable"
            }
        ]
    };
    const priceFormItem: IYhFormItemsBox = {
        // title: "开票信息",
        title:Locale["Invoice Info"],
        style: { padding: "18px 77px 0 0", marginBottom: "15px" },
        items: [
            {
                type: FormItemTypeEnum.Input,
                // fieldLabel: "发票抬头",
                fieldLabel: Locale["Invoice Title"],
                fieldName: "invoiceTitle"
            }, {
                type: FormItemTypeEnum.Input,
                // fieldLabel: "营业执照",
                fieldLabel: Locale["Business License"],
                fieldName: "licenseNo"
            }, {
                type: FormItemTypeEnum.Input,
                // fieldLabel: "开户银行",
                fieldLabel: Locale["Bank"],
                fieldName: "bank"
            }, {
                type: FormItemTypeEnum.Input,
                // fieldLabel: "银行账户",
                fieldLabel: Locale["Bank Account"],
                fieldName: "bankAcct"
            }, {
                type: FormItemTypeEnum.Input,
                // fieldLabel: "邮寄地址",
                fieldLabel: Locale["Mailing Address"],
                fieldName: "postAddress"
            }, {
                type: FormItemTypeEnum.Input,
                // fieldLabel: "公司法人",
                fieldLabel: Locale["Legal Person"],
                fieldName: "corporation"
            }, {
                type: FormItemTypeEnum.Input,
                // fieldLabel: "经营范围",
                fieldLabel: Locale["Business Scope"],
                fieldName: "businessScope"
            }
        ]
    }

    const otherFormItem: IYhFormItemsBox = {
        // title: "其它信息",
        title:Locale["Other Info"],
        // disabled: true,
        style: { padding: "18px 77px 0 0", marginBottom: "15px" },
        items: [
            {
                type: FormItemTypeEnum.Input,
                // fieldLabel: "创建人",
                fieldLabel: Locale["Founder"],
                fieldName: "createUser",
                disable: true
            }, {
                type: FormItemTypeEnum.Input,
                // fieldLabel: "创建时间",
                fieldLabel: Locale["Founder Time"],
                fieldName: "createTime",
                disable: true
            }, {
                type: FormItemTypeEnum.Input,
                // fieldLabel: "修改人",
                fieldLabel: Locale["Updater"],
                fieldName: "updateUser",
                disable: true
            }, {
                type: FormItemTypeEnum.Input,
                // fieldLabel: "修改时间",
                fieldLabel: Locale["Update Time"],
                fieldName: "updateTime",
                disable: true
            }
        ]
    }

    const supplierFromConfig: IYhFormBox = {
        formRef,
        labelCol: { span: 6 },
        labelAlign: "right",
        formValues: detailsInfo.mode === "edit" ? editFormVal : addFormVal,
        onChange,
        boxs: [baseFormItem, priceFormItem, otherFormItem]
    }

    const reset = async () => {
        formRef.current?.resetFields()
        if (detailsInfo.mode === "add") {
            setAddFormVal({})
        } else if (detailsInfo.mode === "edit") {
            getCustomerOne(detailsInfo.id)
        }
        message.success("重置成功")
    }
    const action = <>
        <Button
            className="mr-5"
            type="link"
            shape="round"
            // onClick={onSubmit}
            onClick={debounce(() => { onSubmit() }, 900)}
        >{Locale["Save"]}</Button>
        <Button
            className="mr-5"
            type="link"
            shape="round"
            onClick={() => reset()}
        >{Locale["Reset"]}</Button>
        <Button
            className="mr-5"
            type="link"
            shape="round"
            onClick={onClose}
        >{Locale["Back"]}</Button>
    </>;

    return (
        <>
            <YhPageHeader title={Locale["Customer Details"]} />
            <YhBox title={`${detailsInfo.mode === "edit" ? Locale["Edit Customer"] : Locale["Add Customer"]}`} action={action} style={{ paddingBottom: "0px", marginBottom: "15px" }}></YhBox>
            <YhFormBox {...supplierFromConfig} />
        </>
    )
}